import { Stack } from "@mui/material"
import { Button, Dialog, DialogHandler, fetchRoute, isValidString, TemplatesFactory, TextField } from "@cakemail-org/ui-components-v2"
import { TButtonRef } from "@cakemail-org/ui-components-v2/dist/esm/components/button/types"
import { t } from "i18next"
import { MouseEvent, useLayoutEffect, useState } from "react"
import { getBaseBeeTemplate } from "../../../data/bee"
import { ERoutes } from "../../../utils/url"


function CreateTemplateDialogContent({ resolve, reject }: { resolve: (value: unknown) => void, reject: (reason?: any) => void }) {
    const [name, setName] = useState("")
    const [subject, setSubject] = useState("")

    useLayoutEffect(() => {
        const input = document.querySelector(".createTemplateInput input") as HTMLInputElement
        input?.focus()
    }, [])

    function handleAreaChange(e: React.ChangeEvent<HTMLInputElement>) {
        const value = e.currentTarget.value
        setName(value)
    }
    function handleSubjectChange(e: React.ChangeEvent<HTMLInputElement>) {
        const value = e.currentTarget.value
        setSubject(value)
    }

    function createTemplate(event?: MouseEvent<HTMLButtonElement>, btnRef?: TButtonRef) {
        btnRef?.animate()
        TemplatesFactory.create({
            template: {
                name: name || t("general-untitled"),
                content: {
                    subject,
                    type: "bee",
                    json: getBaseBeeTemplate()
                }
            }
        }).then((data) => {
            btnRef?.reset()
            window.location.href = "#" + fetchRoute({ route: ERoutes.templateEdit, params: { templateId: data.id.toString() } })
            DialogHandler.hide()
            resolve(data)
        }).catch((error) => {
            btnRef?.reset()
            DialogHandler.show({
                isExpress: true,
                type: "error",
                title: t("general-error-action"),
            })
            reject(error)
        })
    }


    return <Stack direction="column" gap={8} marginTop={8}>
        <TextField
            className="createTemplateInput"
            id="createTemplateArea"
            label={t("general-name")}
            placeholder={t("general-template-name-placeholder")}
            value={name}
            onChange={handleAreaChange}
        />

        <TextField
            label={t("general-subject")}
            placeholder={t("general-subject-placeholder")}
            value={subject}
            onChange={handleSubjectChange}
        />

        <Stack direction="row" spacing={2} justifyContent="flex-end" className="dialogBtns">
            <Button
                variant="outlined"
                color="body1"
                size="small"
                onClick={() => {
                    DialogHandler.hide()
                }}
            >
                {t("general-cancel")}
            </Button>
            <Button
                variant="contained"
                color="secondary"
                animated
                onClick={(e, btnRef) => {
                    createTemplate(e, btnRef)
                }}
            >
                {t("general-create")}
            </Button>

        </Stack>
    </Stack>
}


export async function showCreateTemplateDialog() {
    return new Promise((resolve, reject) => {
        DialogHandler.show({
            managedByContent: true,
            title: t("general-create-template"),
            content: (
                <CreateTemplateDialogContent resolve={resolve} reject={reject} />
            ),
        })
    })
}